module.exports = "<div class=\"condition\" *ngIf=\"(programmingCodeitem | async)?.category && ((programmingCodeitem | async)?.device) && !((programmingCodeitem | async)?.condition)\">\n\t<h5>Select a Device Condition</h5>\n\t<prg-list-selector [listSource]=\"(programmingCodeitem | async)?.conditions\" displayField=\"display\" (selected)=\"conditionSelected($event)\"></prg-list-selector>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/select-condition/select-condition.component.html
// module id = 1521
// module chunks = 2